import type { InjectionKey } from 'vue';
import type { NamedRepository } from './named';
export * from './named';

export const repositoryInjectionKey = Symbol(
    'partialRepositoryInjectionKey'
) as InjectionKey<NamedRepository>;
